module.exports = "<div class=\"vms-backup-actions\">\n    <div class=\"progress-state\">\n        <ctx-progressbar min=\"0\" max=\"1\" now=\"$ctrl.progress/100\"\n                         ng-dblclick=\"$ctrl.goToInProgressJob()\"></ctx-progressbar>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/virtualMachines/vmsBackups/vmsBackupActions/vmsBackupActions.template.html
// module id = 448
// module chunks = 0